import { Dispatch } from 'redux';
import { TwilioService } from 'services';
import { sentryException } from 'services/SentryLogging';

import { ActionTypes } from './types';

export const setTwilioInitalized = (dispatch: Dispatch, payload: boolean) => {
    dispatch({
        type: ActionTypes.SET_TWILIO_INITIALIZED,
        payload
    });
};

export const initalizedTwilio = async (dispatch: Dispatch) => {
    try {
        await TwilioService.init();
        setTwilioInitalized(dispatch, true);
    } catch (error) {
        sentryException(error as Error, 'Twilio init failed');
    }
};
